import React from "react";
import { Container } from "../../components";
import {
  AppStoreDownload,
  Circle1,
  HandHoldingPhoneImage2,
  PlayStoreDownload,
} from "../../assets";

const Download = () => {
  return (
    <section className="px-6 py-12 lg:py-24">
      <Container className="bg-[#F8F9FD] rounded-2xl pl-8 pt-8 lg:pb-8 relative overflow-hidden lg:h-[538px] grid md:grid-cols-2 lg:items-center gap-10 lg:gap-20">
        <div className="relative z-[2]">
          <h2 className="text-4xl lg:text-6xl mb-6 pr-6 lg:pr-0">Be the first to know when we launch</h2>
          <p>
            Join Meind Therapy for health and beauty booking: wellness, spa,
            massage, and beauty services made simple for clients and Heros.
          </p>
          <div className="flex items-center gap-5 mt-6">
            <img src={AppStoreDownload} alt="Download Meind Therapy on the App Store" loading="lazy" />
            <img src={PlayStoreDownload} alt="Get Meind Therapy on Google Play" loading="lazy" />
          </div>
        </div>
        <div className="">
          <img
            className="relative lg:absolute z-[2] md:right-0 lg:right-20 bottom-0"
            src={HandHoldingPhoneImage2}
            alt="Booking wellness and beauty appointments with the Meind Therapy app"
            loading="lazy"
          />
          <img
            className="absolute w-[180px] lg:w-[unset] h-[210px] md:h-[unset] right-0 top-0 z-[1]"
            src={Circle1}
            alt=""
            loading="lazy"
            aria-hidden="true"
          />
        </div>
      </Container>
    </section>
  );
};

export default Download;
